import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../server/graphql/__generated.types';

import { ProjectFragmentDoc } from '../../fragments.generated';

const defaultOptions = {} as const;
export type PhoneticReplacementFragment = {
  __typename?: 'PhoneticReplacement';
  actorId?: number | null;
  createdAt: string;
  enabled: boolean;
  id: string;
  isRespelling: boolean;
  libraryId?: string | null;
  replacement: string;
  text: string;
  updatedAt: string;
  userId: string;
};

export type PhoneticLibraryAllQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PhoneticLibraryAllQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    phoneticLibrary: {
      __typename?: 'PhoneticLibrary';
      replacements_V2?: {
        __typename?: 'UserReplacements';
        team?: Array<{
          __typename?: 'PhoneticReplacement';
          actorId?: number | null;
          createdAt: string;
          enabled: boolean;
          id: string;
          isRespelling: boolean;
          libraryId?: string | null;
          replacement: string;
          text: string;
          updatedAt: string;
          userId: string;
        } | null> | null;
        personal?: Array<{
          __typename?: 'PhoneticReplacement';
          actorId?: number | null;
          createdAt: string;
          enabled: boolean;
          id: string;
          isRespelling: boolean;
          libraryId?: string | null;
          replacement: string;
          text: string;
          updatedAt: string;
          userId: string;
        } | null> | null;
      } | null;
    };
  };
};

export type PhoneticLibraryPersonalQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PhoneticLibraryPersonalQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    phoneticLibrary: {
      __typename?: 'PhoneticLibrary';
      replacements_V2?: {
        __typename?: 'UserReplacements';
        personal?: Array<{
          __typename?: 'PhoneticReplacement';
          actorId?: number | null;
          createdAt: string;
          enabled: boolean;
          id: string;
          isRespelling: boolean;
          libraryId?: string | null;
          replacement: string;
          text: string;
          updatedAt: string;
          userId: string;
        } | null> | null;
      } | null;
    };
  };
};

export type PhoneticLibraryTeamQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PhoneticLibraryTeamQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    phoneticLibrary: {
      __typename?: 'PhoneticLibrary';
      replacements_V2?: {
        __typename?: 'UserReplacements';
        team?: Array<{
          __typename?: 'PhoneticReplacement';
          actorId?: number | null;
          createdAt: string;
          enabled: boolean;
          id: string;
          isRespelling: boolean;
          libraryId?: string | null;
          replacement: string;
          text: string;
          updatedAt: string;
          userId: string;
        } | null> | null;
      } | null;
    };
  };
};

export type UserProjectReplacementsQueryVariables = Types.Exact<{
  inputs: Types.UserProjectInputs;
}>;

export type UserProjectReplacementsQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    project?: {
      __typename?: 'Project';
      id: string;
      createdAt: string;
      updatedAt: string;
      folderId?: string | null;
      driveId?: string | null;
      name: string;
      clientName?: string | null;
      clipsCount: number;
      creatorId: string;
      sequence: any;
      shareableUrl?: string | null;
      studioVersion: Types.StudioProjectVersion;
      sampleRate?: number | null;
      rootDriveId?: string | null;
      defaultPauseLength?: number | null;
      bulkPauseLength?: number | null;
      replacements?: Array<{
        __typename?: 'PhoneticReplacement';
        actorId?: number | null;
        createdAt: string;
        enabled: boolean;
        id: string;
        isRespelling: boolean;
        libraryId?: string | null;
        replacement: string;
        text: string;
        updatedAt: string;
        userId: string;
      } | null> | null;
      shareable?: {
        __typename?: 'ProjectShareable';
        url?: string | null;
        deletedAt?: string | null;
      } | null;
      projectAccess: {
        __typename?: 'ProjectAccess';
        id: string;
        viewerAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
          permissions: string;
        } | null;
        teamWideAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
        } | null;
      };
    } | null;
  };
};

export type UpdatePhoneticReplacementMutationVariables = Types.Exact<{
  inputs: Types.PhoneticReplacementInputs;
}>;

export type UpdatePhoneticReplacementMutation = {
  __typename?: 'Mutation';
  phoneticReplacementUpdate: {
    __typename?: 'PhoneticReplacementMutationResponse';
    code: string;
    success: boolean;
    message: string;
    replacement?: {
      __typename?: 'PhoneticReplacement';
      actorId?: number | null;
      createdAt: string;
      enabled: boolean;
      id: string;
      isRespelling: boolean;
      libraryId?: string | null;
      replacement: string;
      text: string;
      updatedAt: string;
      userId: string;
    } | null;
  };
};

export type PhoneticReplacementCreateMutationVariables = Types.Exact<{
  inputs: Types.PhoneticReplacementInputs;
}>;

export type PhoneticReplacementCreateMutation = {
  __typename?: 'Mutation';
  phoneticReplacementCreate: {
    __typename?: 'PhoneticReplacementMutationResponse';
    code: string;
    message: string;
    success: boolean;
    replacement?: {
      __typename?: 'PhoneticReplacement';
      actorId?: number | null;
      createdAt: string;
      enabled: boolean;
      id: string;
      isRespelling: boolean;
      libraryId?: string | null;
      replacement: string;
      text: string;
      updatedAt: string;
      userId: string;
    } | null;
  };
};

export type PhoneticReplacementDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type PhoneticReplacementDeleteMutation = {
  __typename?: 'Mutation';
  phoneticReplacementDelete_V2: {
    __typename?: 'DeletePhoneticReplacementMutationResponse';
    id?: string | null;
    code: string;
    message: string;
    success: boolean;
  };
};

export type SetProjectReplacementsMutationVariables = Types.Exact<{
  inputs: Types.SetProjectReplacementsInputs;
}>;

export type SetProjectReplacementsMutation = {
  __typename?: 'Mutation';
  setProjectReplacements: {
    __typename?: 'SetProjectReplacementsMutationResponse';
    code: string;
    success: boolean;
    message: string;
    project: { __typename?: 'Project'; id: string };
  };
};

export const PhoneticReplacementFragmentDoc = gql`
  fragment PhoneticReplacementFragment on PhoneticReplacement {
    actorId
    createdAt
    enabled
    id
    isRespelling
    libraryId
    replacement
    text
    updatedAt
    userId
  }
`;
export const PhoneticLibraryAllQueryDocument = gql`
  query phoneticLibraryAllQuery {
    user {
      id
      phoneticLibrary {
        replacements_V2 {
          team {
            ...PhoneticReplacementFragment
          }
          personal {
            ...PhoneticReplacementFragment
          }
        }
      }
    }
  }
  ${PhoneticReplacementFragmentDoc}
`;

/**
 * __usePhoneticLibraryAllQuery__
 *
 * To run a query within a React component, call `usePhoneticLibraryAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneticLibraryAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneticLibraryAllQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhoneticLibraryAllQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PhoneticLibraryAllQuery,
    PhoneticLibraryAllQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PhoneticLibraryAllQuery, PhoneticLibraryAllQueryVariables>(
    PhoneticLibraryAllQueryDocument,
    options
  );
}
export function usePhoneticLibraryAllQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhoneticLibraryAllQuery,
    PhoneticLibraryAllQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PhoneticLibraryAllQuery, PhoneticLibraryAllQueryVariables>(
    PhoneticLibraryAllQueryDocument,
    options
  );
}
export type PhoneticLibraryAllQueryHookResult = ReturnType<
  typeof usePhoneticLibraryAllQuery
>;
export type PhoneticLibraryAllQueryLazyQueryHookResult = ReturnType<
  typeof usePhoneticLibraryAllQueryLazyQuery
>;
export type PhoneticLibraryAllQueryQueryResult = Apollo.QueryResult<
  PhoneticLibraryAllQuery,
  PhoneticLibraryAllQueryVariables
>;
export const PhoneticLibraryPersonalQueryDocument = gql`
  query phoneticLibraryPersonalQuery {
    user {
      id
      phoneticLibrary {
        replacements_V2 {
          personal {
            ...PhoneticReplacementFragment
          }
        }
      }
    }
  }
  ${PhoneticReplacementFragmentDoc}
`;

/**
 * __usePhoneticLibraryPersonalQuery__
 *
 * To run a query within a React component, call `usePhoneticLibraryPersonalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneticLibraryPersonalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneticLibraryPersonalQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhoneticLibraryPersonalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PhoneticLibraryPersonalQuery,
    PhoneticLibraryPersonalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PhoneticLibraryPersonalQuery,
    PhoneticLibraryPersonalQueryVariables
  >(PhoneticLibraryPersonalQueryDocument, options);
}
export function usePhoneticLibraryPersonalQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhoneticLibraryPersonalQuery,
    PhoneticLibraryPersonalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PhoneticLibraryPersonalQuery,
    PhoneticLibraryPersonalQueryVariables
  >(PhoneticLibraryPersonalQueryDocument, options);
}
export type PhoneticLibraryPersonalQueryHookResult = ReturnType<
  typeof usePhoneticLibraryPersonalQuery
>;
export type PhoneticLibraryPersonalQueryLazyQueryHookResult = ReturnType<
  typeof usePhoneticLibraryPersonalQueryLazyQuery
>;
export type PhoneticLibraryPersonalQueryQueryResult = Apollo.QueryResult<
  PhoneticLibraryPersonalQuery,
  PhoneticLibraryPersonalQueryVariables
>;
export const PhoneticLibraryTeamQueryDocument = gql`
  query phoneticLibraryTeamQuery {
    user {
      id
      phoneticLibrary {
        replacements_V2 {
          team {
            ...PhoneticReplacementFragment
          }
        }
      }
    }
  }
  ${PhoneticReplacementFragmentDoc}
`;

/**
 * __usePhoneticLibraryTeamQuery__
 *
 * To run a query within a React component, call `usePhoneticLibraryTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneticLibraryTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneticLibraryTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhoneticLibraryTeamQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PhoneticLibraryTeamQuery,
    PhoneticLibraryTeamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PhoneticLibraryTeamQuery, PhoneticLibraryTeamQueryVariables>(
    PhoneticLibraryTeamQueryDocument,
    options
  );
}
export function usePhoneticLibraryTeamQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhoneticLibraryTeamQuery,
    PhoneticLibraryTeamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PhoneticLibraryTeamQuery, PhoneticLibraryTeamQueryVariables>(
    PhoneticLibraryTeamQueryDocument,
    options
  );
}
export type PhoneticLibraryTeamQueryHookResult = ReturnType<
  typeof usePhoneticLibraryTeamQuery
>;
export type PhoneticLibraryTeamQueryLazyQueryHookResult = ReturnType<
  typeof usePhoneticLibraryTeamQueryLazyQuery
>;
export type PhoneticLibraryTeamQueryQueryResult = Apollo.QueryResult<
  PhoneticLibraryTeamQuery,
  PhoneticLibraryTeamQueryVariables
>;
export const UserProjectReplacementsDocument = gql`
  query UserProjectReplacements($inputs: UserProjectInputs!) {
    user {
      id
      project(inputs: $inputs) {
        ...ProjectFragment
        replacements {
          ...PhoneticReplacementFragment
        }
      }
    }
  }
  ${ProjectFragmentDoc}
  ${PhoneticReplacementFragmentDoc}
`;

/**
 * __useUserProjectReplacementsQuery__
 *
 * To run a query within a React component, call `useUserProjectReplacementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectReplacementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectReplacementsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUserProjectReplacementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProjectReplacementsQuery,
    UserProjectReplacementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserProjectReplacementsQuery,
    UserProjectReplacementsQueryVariables
  >(UserProjectReplacementsDocument, options);
}
export function useUserProjectReplacementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProjectReplacementsQuery,
    UserProjectReplacementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserProjectReplacementsQuery,
    UserProjectReplacementsQueryVariables
  >(UserProjectReplacementsDocument, options);
}
export type UserProjectReplacementsQueryHookResult = ReturnType<
  typeof useUserProjectReplacementsQuery
>;
export type UserProjectReplacementsLazyQueryHookResult = ReturnType<
  typeof useUserProjectReplacementsLazyQuery
>;
export type UserProjectReplacementsQueryResult = Apollo.QueryResult<
  UserProjectReplacementsQuery,
  UserProjectReplacementsQueryVariables
>;
export const UpdatePhoneticReplacementDocument = gql`
  mutation updatePhoneticReplacement($inputs: PhoneticReplacementInputs!) {
    phoneticReplacementUpdate(inputs: $inputs) {
      code
      success
      message
      replacement {
        ...PhoneticReplacementFragment
      }
    }
  }
  ${PhoneticReplacementFragmentDoc}
`;
export type UpdatePhoneticReplacementMutationFn = Apollo.MutationFunction<
  UpdatePhoneticReplacementMutation,
  UpdatePhoneticReplacementMutationVariables
>;

/**
 * __useUpdatePhoneticReplacementMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneticReplacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneticReplacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneticReplacementMutation, { data, loading, error }] = useUpdatePhoneticReplacementMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdatePhoneticReplacementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePhoneticReplacementMutation,
    UpdatePhoneticReplacementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePhoneticReplacementMutation,
    UpdatePhoneticReplacementMutationVariables
  >(UpdatePhoneticReplacementDocument, options);
}
export type UpdatePhoneticReplacementMutationHookResult = ReturnType<
  typeof useUpdatePhoneticReplacementMutation
>;
export type UpdatePhoneticReplacementMutationResult =
  Apollo.MutationResult<UpdatePhoneticReplacementMutation>;
export type UpdatePhoneticReplacementMutationOptions = Apollo.BaseMutationOptions<
  UpdatePhoneticReplacementMutation,
  UpdatePhoneticReplacementMutationVariables
>;
export const PhoneticReplacementCreateDocument = gql`
  mutation phoneticReplacementCreate($inputs: PhoneticReplacementInputs!) {
    phoneticReplacementCreate(inputs: $inputs) {
      code
      message
      replacement {
        ...PhoneticReplacementFragment
      }
      success
    }
  }
  ${PhoneticReplacementFragmentDoc}
`;
export type PhoneticReplacementCreateMutationFn = Apollo.MutationFunction<
  PhoneticReplacementCreateMutation,
  PhoneticReplacementCreateMutationVariables
>;

/**
 * __usePhoneticReplacementCreateMutation__
 *
 * To run a mutation, you first call `usePhoneticReplacementCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePhoneticReplacementCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [phoneticReplacementCreateMutation, { data, loading, error }] = usePhoneticReplacementCreateMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function usePhoneticReplacementCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PhoneticReplacementCreateMutation,
    PhoneticReplacementCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PhoneticReplacementCreateMutation,
    PhoneticReplacementCreateMutationVariables
  >(PhoneticReplacementCreateDocument, options);
}
export type PhoneticReplacementCreateMutationHookResult = ReturnType<
  typeof usePhoneticReplacementCreateMutation
>;
export type PhoneticReplacementCreateMutationResult =
  Apollo.MutationResult<PhoneticReplacementCreateMutation>;
export type PhoneticReplacementCreateMutationOptions = Apollo.BaseMutationOptions<
  PhoneticReplacementCreateMutation,
  PhoneticReplacementCreateMutationVariables
>;
export const PhoneticReplacementDeleteDocument = gql`
  mutation phoneticReplacementDelete($id: ID!) {
    phoneticReplacementDelete_V2(id: $id) {
      id
      code
      message
      success
    }
  }
`;
export type PhoneticReplacementDeleteMutationFn = Apollo.MutationFunction<
  PhoneticReplacementDeleteMutation,
  PhoneticReplacementDeleteMutationVariables
>;

/**
 * __usePhoneticReplacementDeleteMutation__
 *
 * To run a mutation, you first call `usePhoneticReplacementDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePhoneticReplacementDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [phoneticReplacementDeleteMutation, { data, loading, error }] = usePhoneticReplacementDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePhoneticReplacementDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PhoneticReplacementDeleteMutation,
    PhoneticReplacementDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PhoneticReplacementDeleteMutation,
    PhoneticReplacementDeleteMutationVariables
  >(PhoneticReplacementDeleteDocument, options);
}
export type PhoneticReplacementDeleteMutationHookResult = ReturnType<
  typeof usePhoneticReplacementDeleteMutation
>;
export type PhoneticReplacementDeleteMutationResult =
  Apollo.MutationResult<PhoneticReplacementDeleteMutation>;
export type PhoneticReplacementDeleteMutationOptions = Apollo.BaseMutationOptions<
  PhoneticReplacementDeleteMutation,
  PhoneticReplacementDeleteMutationVariables
>;
export const SetProjectReplacementsMutationDocument = gql`
  mutation SetProjectReplacementsMutation($inputs: SetProjectReplacementsInputs!) {
    setProjectReplacements(inputs: $inputs) {
      code
      success
      message
      project {
        id
      }
    }
  }
`;
export type SetProjectReplacementsMutationMutationFn = Apollo.MutationFunction<
  SetProjectReplacementsMutation,
  SetProjectReplacementsMutationVariables
>;

/**
 * __useSetProjectReplacementsMutation__
 *
 * To run a mutation, you first call `useSetProjectReplacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectReplacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectReplacementsMutation, { data, loading, error }] = useSetProjectReplacementsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSetProjectReplacementsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetProjectReplacementsMutation,
    SetProjectReplacementsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetProjectReplacementsMutation,
    SetProjectReplacementsMutationVariables
  >(SetProjectReplacementsMutationDocument, options);
}
export type SetProjectReplacementsMutationHookResult = ReturnType<
  typeof useSetProjectReplacementsMutation
>;
export type SetProjectReplacementsMutationMutationResult =
  Apollo.MutationResult<SetProjectReplacementsMutation>;
export type SetProjectReplacementsMutationMutationOptions = Apollo.BaseMutationOptions<
  SetProjectReplacementsMutation,
  SetProjectReplacementsMutationVariables
>;
